'use client';

import ProductCard from '@repo/ui/src/components/ContentGrid/ProductCard';
import RelatedGrid from '@repo/ui/src/components/RelatedGrid';
import useProducts from '@hooks/product/useProducts';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { ImageProps } from '@repo/ui/src/types/image';
import { ProductModelProps } from '@typings/product';
import { useVipAccess } from '@hooks/customer';

interface Props {
  toutContent?: ToutContentProps;
  backgroundImage?: ImageProps;
  saleText?: string;
  newText?: string;
  _data: Array<ProductModelProps>;
}

const RelatedProductGridBoundary = ({
  toutContent,
  backgroundImage,
  saleText,
  newText,
  _data = [],
}: Props) => {
  const { products } = useProducts(_data);
  const { vip } = useVipAccess();

  return (
    <RelatedGrid
      toutContent={toutContent}
      backgroundImage={backgroundImage}
      gridClassName="tw-border-l tw-border-t tw-border-neutral-200"
    >
      {products.slice(0, 6).map((product, index) => (
        <li key={index} className="[&:nth-child(n+5)]:tw-hidden lg:[&:nth-child(n+5)]:tw-block">
          <ProductCard
            product={product}
            backgroundStyle="Light"
            vip={vip}
            newText={newText}
            saleText={saleText}
          />
        </li>
      ))}
    </RelatedGrid>
  );
};

export default RelatedProductGridBoundary;
